module.exports = __webpack_public_path__ + "static/media/carolyn-testimonial.9e7a7132.png";